import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=05df8558"
import script from "./Lessons.vue?vue&type=script&lang=ts"
export * from "./Lessons.vue?vue&type=script&lang=ts"
import style0 from "./Lessons.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports